import cls from "classnames";

import {MultiCurrency} from "../../../../../common/utils/currency";
import * as Posthog from "@qoohoo/common/utils/analytics/posthog";

import Spinner from "../../../../../common/library/loader/Spinner";
import Layout from "../Layout";
import Form from "../../form/Form";
import {ButtonPrimary} from "../../../../../common/components/library/Button";
import { WhatsAppInfoBanner } from "components/InfoBanner";

import CouponField from "../../CouponField";
import LoginForm from "../../../components/form/LoginForm";
import FeeBreakup from "../../FeeBreakup";
import PaymentTermsConsentForm from "../PaymentTermsConsentForm";


import useEntityStore from "store/entityStore";
import useCustomerStore from "store/customerStore";
import usePreferencesStore from "store/preferencesStore";
import useCouponState from "store/couponState";
import useAppState from "store/appState";
import {modalPortal} from "store/modalPortalState";

import createOrder from "utils/createOrder";
import setupNewUser from "utils/setupNewUser";

// TODO: Make it config driven, currently hard coding this
import {useMemo, useState} from "react";
import {ModalPortalContent} from "../../ModalPortal";
import getFormConfig from "./config/getFormConfig";

export default function CustomerForm1 (props) {
  const entity = useEntityStore(state => state.entity);
  const [
    order, setIsOrderCreating, setOrderObj,
    setIsPaymentGatewayOpened
  ] = useAppState(state => [
    state.order, state.setIsOrderCreating, state.setOrderObj,
    state.setIsPaymentGatewayOpened
  ]);
  const couponDUMMY = useCouponState(state => state.coupon);

  const customer = useCustomerStore((state) => state.customer?.data);
  const preferences = usePreferencesStore((state) => state.preferences?.data);

  const [isPaymentTermsConsentDone, setIsPaymentTermsConsentDone] = useState(false);

  const askPaymentTermsConsent = !!entity.data.payment.consentTerms;
  const showCustomerForm = (!preferences.isCustomerAuthRequired || !!customer); // just masking and not hiding

  const formConfig = useMemo(() => {
    return getFormConfig(preferences.prePaymentForm);
  }, [preferences.prePaymentForm]);

  function handleCheckoutBtnAnalytics() {
    const data = {
      user_uid: customer?.uid,
      entity_uid: entity?.data?.uid,
      entity_type: entity?.data?.type,
      creator_uid: entity?.data?.creator?.uid,
      entity_name: entity?.data?.name,
      current_screen: "checkout_view",
      current_route: window.location.pathname,
      payment_gateway: entity?.data?.payment?.paymentGateway,
      total_amount:
        entity?.data?.payment?.plans?.[0]?.data?.amount_after_discount ??
        entity?.data?.payment?.plans?.[0]?.data?.amount,
      currency: entity?.payment?.currency,
      subscription_plan_interval:
        entity?.data?.payment?.plans?.[0]?.data?.interval,
      subscription_plan_duration:
        entity?.data?.payment?.plans?.[0]?.data?.duration,
      platform: "web",
    };

    console.log("Posthog button click data: checkout_cta_btn", data);

    Posthog.buttonClick("checkout_cta_btn", data);
  }

  async function handleOnSubmit(formData) {
    console.log('Form..', formData);

    handleCheckoutBtnAnalytics();

    if (askPaymentTermsConsent && !isPaymentTermsConsentDone) {
      try {
        const isAccepted = await showPaymentTermsForm();

        if (isAccepted) {
          modalPortal.close();
          setIsPaymentTermsConsentDone(true);
          return await continueToPay(formData);
        }
      } catch(err) {
          modalPortal.close();
        // Note: Silent fail
        // TODO: Can track events to track funnel drop offs
      }
    } else {
      return await continueToPay(formData);
    }
  }

  function handleOnAccept(resolve) {
    const data = {
      user_uid: customer?.uid,
      entity_uid: entity?.data?.uid,
      entity_type: entity?.data?.type,
      creator_uid: entity?.data?.creator?.uid,
      entity_name: entity?.data?.name,
      current_screen: "consent_form_view",
      current_route: window.location.pathname,
      payment_gateway: entity?.data?.payment?.paymentGateway,
      total_amount:
        entity?.data?.payment?.plans?.[0]?.data?.amount_after_discount ??
        entity?.data?.payment?.plans?.[0]?.data?.amount,
      currency: entity?.data?.payment?.currency,
      subscription_plan_interval:
        entity?.data?.payment?.plans?.[0]?.data?.interval,
      subscription_plan_duration:
        entity?.data?.payment?.plans?.[0]?.data?.duration,
      platform: "web",
    };

    console.log("Posthog button click data: pre_payment_cta_btn", data);

    Posthog.buttonClick("pre_payment_cta_btn", data);
    resolve(true);
  }

  function handleOnReject(reject) {
    const data = {
      user_uid: customer?.uid,
      entity_uid: entity?.data?.uid,
      entity_type: entity?.data?.type,
      creator_uid: entity?.data?.creator?.uid,
      entity_name: entity?.data?.name,
      current_screen: "consent_form_view",
      current_route: window.location.pathname,
      payment_gateway: entity?.data?.payment?.paymentGateway,
      total_amount:
        entity?.data?.payment?.plans?.[0]?.data?.amount_after_discount ??
        entity?.data?.payment?.plans?.[0]?.data?.amount,
      currency: entity?.data?.payment?.currency,
      subscription_plan_interval: entity?.data?.payment?.plans?.[0]?.data?.interval,
      subscription_plan_duration: entity?.data?.payment?.plans?.[0]?.data?.duration,
      platform: "web",
    };

    console.log("Posthog button click data: pre_payment_close_btn", data);

    Posthog.buttonClick("pre_payment_close_btn", data);
    reject();
  }

  async function showPaymentTermsForm() {
    return new Promise((resolve, reject) => {
      modalPortal.open(
        <PaymentTermsConsentForm
          onAccept={() => {
            handleOnAccept(resolve);
          }}
          onReject={() => {
            handleOnReject(reject);
          }}
        />);
    });
  }

  async function continueToPay (formData) {
    const userExtraData = {...formData};

    try {
      setIsOrderCreating(true);

      if(!customer.name) {
        await setupNewUser(userExtraData.name);
      }

      const orderObj = await createOrder(userExtraData);

      if (orderObj) {
        setOrderObj(orderObj);

        setIsPaymentGatewayOpened(true);

        return orderObj;
      }
    } finally {
      setIsOrderCreating(false);
    }
  }

  return (
    <div className="flex flex-col h-full w-full relative">
      <Layout className={cls("flex-1")}>
        <WhatsAppInfoBanner />
        {
          preferences.isCustomerAuthRequired && (
            <LoginForm />
          )
        }

        <Form
          formConfig={formConfig}
          onSubmit={handleOnSubmit}
          disabled={!showCustomerForm}
          isMasked={!showCustomerForm}
        >
          {({disabled}) => <PayButtonFooter entity={entity} disabled={disabled} />}
        </Form>

        {
          !order.isRecurring && (
            <div className="mt-4">
              <CouponField />
            </div>
          )
        }

        {
          (order.isCouponApplied || !order.isTaxInclusive || order.hasConvenienceFee) && (
            <div className="mt-4">
              <FeeBreakup />
            </div>
          )
        }
      </Layout>
    </div>
  );
}

CustomerForm1.title = "Fill your details";

// TODO: Handle case of free payments
function PayButtonFooter(props) {
  const {disabled} = props;
  const couponDUMMY = useCouponState(state => state.coupon);
  const [order, isLoadingFeeBreakup] = useAppState(state => [state.order, state.isLoadingFeeBreakup]);

  const amountToPayLabel = order.amountToPay ? MultiCurrency.formatAmountWithSymbol(
    order.amountToPay,
    order.currency
  ) : null;

  const showLoader = isLoadingFeeBreakup;

/*
  const taxInfo = (
    (order.isCouponApplied || !order.isTaxInclusive || order.hasConvenienceFee) ?  (
      <Anchor href="#feebreakup-section" className="text-xs text-[#9EA1A3] font-semibold">
        View details
      </Anchor>
    ) : "(inclusive of taxes)"
  );
*/
  const taxInfo = "Payable amount";

  return (
    <div
      className={cls(
        "absolute bottom-0 pb-6 z-10 flex pt-2 px-4 w-full left-0 items-center",
        "bg-white shadow-[0_-4px_10px_rgba(0,0,0,0.05)]"
      )}
    >
      {/*Payment info*/}
      <div className="flex flex-col min-w-[120px] items-start">
        {
          (showLoader) ? (
            <Spinner color="rgba(0,0,0,0.2)" className="!h-4 !w-4 mb-3" />
          ) : (
            <div className="text-lg font-bold">
              {amountToPayLabel}
            </div>
          )
        }

        <div className="text-xs text-[#9EA1A3]">
          {taxInfo}
        </div>
      </div>

      <ButtonPrimary
        className={cls(
          "flex-1 ml-4 overflow-hidden",
          !disabled && "animate-glimmer-pay",
          "bg-primary"
        )}
        doOpacityForDisabled
        disabled={disabled}
        type="submit"
      >
        Pay
      </ButtonPrimary>
    </div>
  )
}